import { render, staticRenderFns } from "./WebOffice.vue?vue&type=template&id=3a43fab1&scoped=true&"
import script from "./WebOffice.vue?vue&type=script&lang=js&"
export * from "./WebOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43fab1",
  null
  
)

export default component.exports